'use strict';

import angular from 'angular';

import uiRouter from 'angular-ui-router';

import routing from './appstore.routes';

import list from './list';
import show from './show';
import add from './add';
import edit from './edit';
import addConf from './addConf';
import editConf from './editConf';

export default angular.module('updateServerApp.appstore', [uiRouter, list, show, edit, addConf, editConf, add])
  .config(routing)
  .run(function($rootScope) {
    'ngInject';

    $rootScope.$on('$stateChangeStart', function(event, next, nextParams, current) {
      if(next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
      }
    });
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/appstore/index.js